import TabsMenuContainer from './tabs_menu_container';

export default TabsMenuContainer;
